<template>
    <div class="content-item-container">
        <div class="content-item-icon"><img :src="item.icon"></div>
        <div class="content-item-text">
            <div class="content-item-num-c"><span class="content-item-num">{{ item.num }}</span><span class="content-item-unit">{{ item.unit }}</span></div>
            <div class="content-item-desc">{{ item.desc }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ContentItem',
    props: [
        'item'
    ]
}
</script>
<style scoped lang="less">
.content-item-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    min-height: 63px;

    .content-item-icon {
        flex: none;
        display: flex;
        align-items: center;

        img {
            display: block;
            width: 69px;
            height: 63px;
        }
    }

    .content-item-text {
        height: 63px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .content-item-num-c {
            height: 35px;
            display: flex;
            align-items: flex-end;
            .content-item-num {
                color: #D8E2FF;
                font-size: 12pt;
                font-weight: bold;
                font-style: italic;
            }

            .content-item-unit {
                color: #9ca1ad;
                font-size: 8pt;
                font-weight: thin;
                display: inline-block;
                margin-left: 5px;
                font-style: italic;
            }
        }

        .content-item-desc {
            height: 15px;
            color: #9ca1ad;
            font-size: 9pt;
            font-weight: light;
            flex: none;
            font-style: italic;
        }
    }
}
</style>
